import React, { useState } from 'react';
import { redirect, useLoaderData, useNavigation } from 'react-router-dom';
import { toast } from 'react-toastify';
import customFetch from '../../../../utils/customFetch';
import CardVorschau from '../../../bestellungen/CardVorschau';
import { PDFDownloadLink } from '@react-pdf/renderer';
import Invoice from '../../bestellungen/Invoice';
import { CARD_STATUS, ORDER_STATUS } from '../../../../../../utils/constants';

export const loader = async ({ params }) => {
  try {
    const { data } = await customFetch.get(`/orders/${params.id}`);
    return data;
  } catch (error) {
    toast.error(error?.response?.data?.msg);
    return redirect('/dashboard/bestellbearbeitung');
  }
};

const OrderDetail = () => {
  const order = useLoaderData().singleOrder;
  const cards = useLoaderData().cards;

  const [orderStatus, setOrderStatus] = useState(order.status);

  console.log(order);
  console.log(cards);

  const navigation = useNavigation();
  const isSubmitting = navigation.state === 'submitting';

  const updateCard = async (event, cardId) => {
    event.preventDefault();
    const data = {
      status: event.target.status.value,
    };
    try {
      await customFetch.patch(`/cards/${cardId}`, data);
      toast.success('Erfolgreich angepasst!');
      return redirect('/dashboard/bestellbearbeitung');
    } catch (error) {
      toast.error(error?.response?.data?.msg);
      return redirect('/dashboard/bestellbearbeitung');
      return error;
    }
  };

  const updateOrder = async (event) => {
    event.preventDefault();
    const data = {
      status: event.target.status.value,
      trackingNumber: event.target.trackingNumber?.value,
    };

    if (data.status === ORDER_STATUS.GELIEFERT && !trackingNumber) {
      toast.error(
        'Für den Status geliefert wird eine Sendungsverfolgungsnummer benötigt.'
      );
      return;
    }
    try {
      await customFetch.patch(`/orders/${order._id}`, data);
      toast.success('Erfolgreich angepasst!');
      return redirect('/dashboard/bestellbearbeitung');
    } catch (error) {
      toast.error(error?.response?.data?.msg);
      return redirect('/dashboard/bestellbearbeitung');
      return error;
    }
  };

  const copyToClipboard = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        toast.success('Kopiert!');
      })
      .catch((err) => {
        toast.error('Failed to copy: ', err);
      });
  };

  return (
    <>
      <nav aria-label="Breadcrumb">
        <ol role="list" className="flex items-center space-x-2">
          <li>
            <div className="flex items-center text-sm">
              <a
                href="/dashboard/bestellbearbeitung"
                className="font-medium text-gray-500 hover:text-gray-900"
              >
                Zurück zu allen Bestellungen
              </a>
            </div>
          </li>
        </ol>
      </nav>

      <main className="mx-auto max-w-2xl pb-24 pt-8 sm:px-6 sm:pt-16 lg:max-w-7xl lg:px-8">
        <div className="space-y-2 px-4 sm:flex sm:items-baseline sm:justify-between sm:space-y-0 sm:px-0">
          <div className="flex sm:items-baseline sm:space-x-4">
            <h1 className="text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl">
              Bestellung #{order.orderNumber}
            </h1>
            <PDFDownloadLink
              document={<Invoice order={order} />}
              fileName={`Rechnung_${order.orderNumber || order._id}.pdf`}
              className="hidden text-sm font-medium text-svisit-primary-600 hover:text-svisit-primary-500 sm:block"
            >
              Rechnung ansehen
              <span aria-hidden="true"> &rarr;</span>
            </PDFDownloadLink>
          </div>
          <p className="text-sm text-gray-600">
            Bestellung vom{' '}
            <time
              dateTime={order.createdAt.split('T')[0]}
              className="font-medium text-gray-900"
            >
              {order.createdAt.split('T')[0]}
            </time>
          </p>
          <PDFDownloadLink
            document={<Invoice order={order} />}
            fileName={`Rechnung_${order.orderNumber || order._id}.pdf`}
            className="text-sm font-medium text-svisit-primary-600 hover:text-svisit-primary-500 sm:hidden"
          >
            Rechnung ansehen
            <span aria-hidden="true"> &rarr;</span>
          </PDFDownloadLink>
        </div>

        {/* Products */}
        <section aria-labelledby="products-heading" className="mt-6">
          <h2 id="products-heading" className="sr-only">
            Gekaufte Produkte
          </h2>

          <div className="space-y-8">
            {cards.map((card) => (
              <div
                key={card._id}
                className="border-b border-t border-gray-200 bg-white shadow-xs sm:rounded-lg sm:border"
              >
                <div className="px-4 py-6 sm:px-6 lg:grid lg:grid-cols-12 lg:gap-x-8 lg:p-8">
                  <div className="sm:flex lg:col-span-7 gap-x-4">
                    <div className="w-full">
                      <CardVorschau
                        className="h-full w-full object-cover object-center sm:h-full sm:w-full"
                        bildInfos={card.graphicFront}
                      />
                    </div>

                    <div className="w-full">
                      <CardVorschau
                        className="h-full w-full object-cover object-center sm:h-full sm:w-full"
                        bildInfos={card.graphicBack}
                      />
                    </div>
                  </div>

                  <div className="mt-6 lg:col-span-5 lg:mt-0">
                    <dl className="grid gap-x-6 text-sm">
                      <div>
                        <dt className="text-xl font-bold text-gray-900">
                          <p>{card.name}</p>
                        </dt>
                        <dd className="mt-3 text-gray-700">
                          <span className="block">
                            Hier kommt irgendwann noch die genauere Anleitung,
                            wie man die Karte erstellen kann. Pressiert aber nöd
                            oder
                          </span>
                        </dd>
                      </div>
                    </dl>
                  </div>
                </div>

                <div className="border-t border-gray-200 px-4 py-6 sm:px-6 lg:p-8">
                  <h4 className="sr-only">Bearbeitungsinfos</h4>
                  <p className="text-xl font-bold text-gray-900">
                    Weitere Bearbeitungsinfos
                  </p>

                  <p className="text-base font-medium text-gray-900 mt-4">
                    URL der Karte
                  </p>

                  <p
                    className="inline-flex rounded-md border-0 mt-2 px-2.5 py-2 shadow-xs ring-1 placeholder:text-gray-400 focus:ring-2 focus:ring-inset cursor-pointer bg-gray-50 text-gray-500 ring-gray-200 sm:text-sm sm:leading-6"
                    onClick={() =>
                      copyToClipboard(`app.svisit.ch/l/${card.url}`)
                    }
                  >
                    {`app.svisit.ch/l/${card.url}`}
                  </p>

                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-4">
                    {/* Column 1 */}
                    <div>
                      <h5 className="text-base font-medium text-gray-900">
                        Vorderseite
                      </h5>
                      {card.graphicFront.startsWith('{"Farbe') ? (
                        (() => {
                          // Parse the JSON inline
                          const parsedData = JSON.parse(card.graphicFront);
                          return (
                            <div className="flex-col">
                              <p
                                className="max-w-fit rounded-md border-0 mt-2 px-2.5 py-2 shadow-xs ring-1 placeholder:text-gray-400 focus:ring-2 focus:ring-inset cursor-pointer bg-gray-50 text-gray-500 ring-gray-200 sm:text-sm sm:leading-6"
                                onClick={() =>
                                  copyToClipboard(`${parsedData.Farbe}`)
                                }
                              >
                                Farbe: {parsedData.Farbe}
                              </p>

                              {parsedData.QR_Code ? (
                                <p
                                  className="max-w-fit rounded-md border-0 mt-2 px-2.5 py-2 shadow-xs ring-1 placeholder:text-gray-400 focus:ring-2 focus:ring-inset cursor-pointer bg-gray-50 text-gray-500 ring-gray-200 sm:text-sm sm:leading-6"
                                  onClick={() =>
                                    copyToClipboard(
                                      `${parsedData.QR_Code_Farbe}`
                                    )
                                  }
                                >
                                  QR Code Farbe: {parsedData.QR_Code_Farbe}
                                </p>
                              ) : (
                                ''
                              )}
                            </div>
                          );
                        })()
                      ) : (
                        <p
                          className=" overflow-hidden rounded-md border-0 mt-2 px-2.5 py-2 shadow-xs ring-1 placeholder:text-gray-400 focus:ring-2 focus:ring-inset cursor-pointer bg-gray-50 text-gray-500 ring-gray-200 sm:text-sm sm:leading-6"
                          onClick={() =>
                            copyToClipboard(`${card.graphicFront}`)
                          }
                        >
                          {card.graphicFront}
                        </p>
                      )}
                    </div>

                    {/* Column 2 */}
                    <div>
                      <h5 className="text-base font-medium text-gray-900">
                        Rückseite
                      </h5>

                      {card.graphicBack.startsWith('{"Farbe') ? (
                        (() => {
                          // Parse the JSON inline
                          const parsedData = JSON.parse(card.graphicBack);
                          return (
                            <div className="flex-col">
                              <p
                                className="max-w-fit rounded-md border-0 mt-2 px-2.5 py-2 shadow-xs ring-1 placeholder:text-gray-400 focus:ring-2 focus:ring-inset cursor-pointer bg-gray-50 text-gray-500 ring-gray-200 sm:text-sm sm:leading-6"
                                onClick={() =>
                                  copyToClipboard(`${parsedData.Farbe}`)
                                }
                              >
                                Farbe: {parsedData.Farbe}
                              </p>

                              {parsedData.QR_Code ? (
                                <p
                                  className="max-w-fit rounded-md border-0 mt-2 px-2.5 py-2 shadow-xs ring-1 placeholder:text-gray-400 focus:ring-2 focus:ring-inset cursor-pointer bg-gray-50 text-gray-500 ring-gray-200 sm:text-sm sm:leading-6"
                                  onClick={() =>
                                    copyToClipboard(
                                      `${parsedData.QR_Code_Farbe}`
                                    )
                                  }
                                >
                                  QR Code Farbe: {parsedData.QR_Code_Farbe}
                                </p>
                              ) : (
                                ''
                              )}
                            </div>
                          );
                        })()
                      ) : (
                        <p
                          className="overflow-hidden rounded-md border-0 mt-2 px-2.5 py-2 shadow-xs ring-1 placeholder:text-gray-400 focus:ring-2 focus:ring-inset cursor-pointer bg-gray-50 text-gray-500 ring-gray-200 sm:text-sm sm:leading-6"
                          onClick={() => copyToClipboard(`${card.graphicBack}`)}
                        >
                          {card.graphicBack}
                        </p>
                      )}
                    </div>
                  </div>

                  {/* Hier Kartenstatus anpassen */}
                  <p className="text-xl font-bold text-gray-900 my-4">
                    Kartenstatus verwalten
                  </p>
                  <form
                    onSubmit={(event) => updateCard(event, card._id)}
                    className="flex flex-col"
                  >
                    <div className="col-span-full lg:max-w-xs">
                      <label
                        htmlFor={`${card._id}-status`}
                        className="block text-base font-medium text-gray-900"
                      >
                        Status
                      </label>
                      <div className="mt-2">
                        <select
                          id="status"
                          name={`${card._id}-status`}
                          defaultValue={card.status}
                          className="block w-full rounded-md border-0 bg-white/5 px-3 py-1.5 text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-svisit-primary-500 sm:text-sm sm:leading-6"
                        >
                          {Object.values(CARD_STATUS).map((status) => (
                            <option key={status} value={status}>
                              {status}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="mt-4 flex">
                      <button
                        type="submit"
                        className="rounded-md bg-svisit-primary-500 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-svisit-primary-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-svisit-primary-500"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? 'Speichert...' : 'Speichern'}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Billing */}
        <section aria-labelledby="summary-heading" className="mt-16">
          <h2 id="summary-heading" className="sr-only">
            Rechnungszusammenfassung
          </h2>

          <div className="bg-gray-100 px-4 py-6 sm:rounded-lg sm:px-6 lg:grid lg:grid-cols-12 lg:gap-x-8 lg:px-8 lg:py-8">
            <dl className="grid grid-cols-2 gap-6 text-sm sm:grid-cols-2 md:gap-x-8 lg:col-span-7">
              <div>
                <dt className="font-medium text-gray-900">Versandadresse</dt>
                <dd className="mt-3 text-gray-500">
                  <span className="block">{order.address[0].company}</span>
                  <span className="block">
                    {order.address[0].firstName} {order.address[0].lastName}
                  </span>
                  <span className="block">{order.address[0].address}</span>
                  <span className="block">
                    {order.address[0].zip} {order.address[0].city}
                  </span>
                  <span className="block">{order.address[0].phone}</span>
                </dd>
              </div>
              <div>
                <dt className="font-medium text-gray-900">
                  Bezahlinformationen
                </dt>
                <dd className="-ml-4 -mt-1 flex flex-wrap">
                  <div className="ml-4 mt-4">
                    <p className="text-gray-500">
                      STRIPE (genauer kommt noch...)
                    </p>
                  </div>
                </dd>
              </div>
            </dl>

            <dl className="mt-8 divide-y divide-gray-200 text-sm lg:col-span-5 lg:mt-0">
              <div className="flex items-center justify-between pb-4">
                <dt className="text-gray-600">Zwischentotal</dt>
                <dd className="font-medium text-gray-900">
                  {order.subtotal / 100} CHF
                </dd>
              </div>
              <div className="flex items-center justify-between py-4">
                <dt className="text-gray-600">Versand</dt>
                <dd className="font-medium text-gray-900">
                  {order.shippingFee / 100} CHF
                </dd>
              </div>
              <div className="flex items-center justify-between py-4">
                <dt className="text-gray-600">Enthaltene MwSt.:</dt>
                <dd className="font-medium text-gray-900">
                  {order.tax / 100} CHF
                </dd>
              </div>
              <div className="flex items-center justify-between pt-4">
                <dt className="font-medium text-gray-900">Bestelltotal</dt>
                <dd className="font-medium text-svisit-primary-600">
                  {order.total / 100} CHF
                </dd>
              </div>
            </dl>
            <dl className="mt-4 border-t border-gray-200 col-span-12 grid grid-cols-1 lg:grid-cols-2 gap-6 sm:grid-cols-2 md:gap-x-8">
              <div>
                <p className="my-4 text-xl font-bold text-gray-900">
                  Bestellbearbeitung
                </p>
                <form
                  onSubmit={(event) => updateOrder(event)}
                  className="flex flex-col"
                >
                  <div className="col-span-full lg:max-w-xs">
                    <label
                      htmlFor="orderStatus"
                      className="block text-base font-medium text-gray-900"
                    >
                      Status
                    </label>
                    <div className="mt-2">
                      <select
                        id="status"
                        name="orderStatus"
                        defaultValue={orderStatus}
                        onChange={(e) => setOrderStatus(e.target.value)}
                        className="block w-full rounded-md border-0 bg-white px-3 py-1.5 text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-svisit-primary-500 sm:text-sm sm:leading-6"
                      >
                        {Object.values(ORDER_STATUS).map((status) => (
                          <option key={status} value={status}>
                            {status}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {orderStatus === ORDER_STATUS.GELIEFERT && (
                    <div className="col-span-full lg:max-w-xs mt-4">
                      <label
                        htmlFor="trackingNumber"
                        className="block text-base font-medium text-gray-900"
                      >
                        Sendungsverfolgungsnummer
                      </label>
                      <div className="mt-2">
                        <input
                          type="text"
                          id="trackingNumber"
                          name="trackingNumber"
                          defaultValue={order.trackingNumber || ''}
                          required
                          className="block w-full rounded-md border-0 bg-white px-3 py-1.5 text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-svisit-primary-500 sm:text-sm sm:leading-6"
                          placeholder="Sendungsnummer"
                        />
                      </div>
                      <p
                        id="trackingNumber-description"
                        className="mt-2 text-sm text-gray-500"
                      >
                        Achtung! Beim Speichern wird die Bestellbestätigung an
                        den Nutzer gesendet.
                      </p>
                    </div>
                  )}

                  <div className="mt-4 flex">
                    <button
                      type="submit"
                      className="rounded-md bg-svisit-primary-500 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-svisit-primary-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-svisit-primary-500"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? 'Speichert...' : 'Speichern'}
                    </button>
                  </div>
                </form>
              </div>
            </dl>
          </div>
        </section>
      </main>
    </>
  );
};

export default OrderDetail;
